var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useRef, useState } from 'react';
import { FormatDate } from '@components/Shared/Utils';
import html2pdf from 'html2pdf.js';
import html2canvas from 'html2canvas';
const useInvoiceDownloader = (order, type) => {
    const rootElement = useRef(null);
    const footerElement = useRef(null);
    const [dowloading, setDownloading] = useState(false);
    const handleDownload = useCallback((e, showOnly = false) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (!footerElement.current || !rootElement.current || !order || !type) {
            return;
        }
        setDownloading(true);
        try {
            const opt = {
                margin: 0.25,
                filename: `${type}-${order.orderNumber}-${FormatDate(new Date(), 'yyyyMMdd')}.pdf`,
                image: { type: 'jpeg', quality: 1.0 },
                html2canvas: { dpi: 75, scale: 1.5, letterRendering: true },
                jsPDF: { orientation: 'portrait', unit: 'in', format: 'a4' },
            };
            const footerCanvas = yield html2canvas(footerElement.current);
            const footerImage = footerCanvas.toDataURL('image/jpg');
            const pdfFile = html2pdf()
                .set(opt)
                .from(rootElement.current)
                .toPdf()
                .get('pdf')
                .then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages();
                for (let page = 1; page <= totalPages; page++) {
                    pdf.setPage(page);
                    pdf.setFontSize(8);
                    pdf.setTextColor(0);
                    if (totalPages === page) {
                        pdf.addImage(footerImage, 'jpg', 0.25, pdf.internal.pageSize.getHeight() - 1.75, pdf.internal.pageSize.getWidth() - 0.5, 1.5);
                    }
                    pdf.text(pdf.internal.pageSize.getWidth() - 4, pdf.internal.pageSize.getHeight() - 0.1, page + ' / ' + totalPages, 'right');
                }
                if (showOnly) {
                    globalThis.open(pdf.output('bloburl'), '_blank');
                }
            });
            if (!showOnly) {
                pdfFile.save();
            }
            pdfFile.then(() => setDownloading(false));
        }
        catch (e) {
            console.error(e);
            setDownloading(false);
        }
    }), [order, type]);
    return { rootElement, footerElement, dowloading, handleDownload };
};
export default useInvoiceDownloader;
